import PropTypes from 'prop-types';
import { createContext, PropsWithChildren, useMemo } from 'react';

// project imports
import config from 'config';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { ConfigContextValue, ConfigStates } from 'types/config';

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }: PropsWithChildren) {
  // Storage key version-bumped whenever config.js defaults change in a way that
  // would otherwise be masked by old persisted state. History:
  //   v1 → initial Weightrax preset + Inter + light theme + navy sidebar
  //   v2 → fluid content (container: false) per Path B Figma 2026-05-09
  const { state, setState, setField, resetState } = useLocalStorage<ConfigStates>('weightrax-config-v2', config);

  const memoizedValue = useMemo<ConfigContextValue>(
    () => ({
      state,
      setState,
      setField: (name, updateValue) => setField(name, updateValue),
      resetState
    }),
    [state, setField, setState, resetState]
  );

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}

ConfigProvider.propTypes = { children: PropTypes.node };
